<template>
  <div
    class="threesixty-block"
    :class="{opaque: opaque}"
  >
    <div class="threesixty-block__image-wrapper" v-if="image">
      <movie-player class="threesixty-block__video" v-if="video" :movieUrl="video" :placeholderUrl="image" autoplay="true"></movie-player>
      <img class="threesixty-block__image" v-if="!video" :src="image" />
    </div>
    <div class="threesixty-block__content-wrapper">
      <a class="threesixty-block__close" v-if="close" @click="$emit('close', $event)"></a>
      <div class="threesixty-block__textwrap" @click="$emit('click', $event)">
        <h2 class="threesixty-block__title"><span v-if="index" class="number">{{index}}.</span> <span v-html="title"></span></h2>
        <div class="threesixty-block__content" v-html="content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import MoviePlayer from '@/components/MoviePlayer';

export default {
  name: 'threesixty',
  components: { MoviePlayer },
  props: {
    image: {
      type: [String, Boolean],
    },
    video: {
      type: [String, Boolean],
    },
    opaque: {
      type: Boolean,
    },
    close: {
      type: Boolean,
    },
    index: {
      type: [Number, String, Boolean],
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../scss/helpers';

.threesixty-block {

  background: $c_white;
  margin-bottom: 20px;
  box-sizing: border-box;
  // order: 2;

  &--title {
    color: $c_white;
    padding: 30px;
    background: $c_primary;
    // order: 1;

    @include not-laptop {
      display: none;
    }
  }

  &.opaque {
    opacity: .5;

    @include not-laptop {
      display: none;
    }

    @include landscape {
      display: block;
    }
  }

  &__title {
    @include font-block-title;
    
    .number {
      color: $c_primary;

      @include mobile {
        display: none;
      }

      @include landscape {
        display: none;
      }
    }
  }

  &__content-wrapper {
    position: relative;
  }

  &__content {
    @include font-block-content;
    line-height: 2.3333;
  }

  &__image-wrapper {
    display: block;
    width: 100%;
    position: relative;
    overflow: hidden;
  }

  &__image {
    display: block;
    width: 100%;
  }

  &__textwrap {
    padding: 40px 30px;
    position: relative;
  }

  &__close {
    background: #0096C3;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: block;
    position: absolute;
    top: -20px;
    right: -20px;
    z-index: 1;
    -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.31);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.31);
    -webkit-transition: all .25s;
    transition: all .25s;
    cursor: pointer;

    &:before, &:after {
      content: '';
      background: #fff;
      display: block;
      height: 2px;
      left: 11px;
      position: absolute;
      top: 19px;
      transform: rotate(-45deg);
      width: 18px;
      z-index: 10;
      transition: all .25s;
    }

    &:before {
      transform: rotate(45deg);
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ThreeSixtyBlock.vue